import classNames from "classnames";
import "./index.scss";

interface IProps {
  placeholder?: string;
  value?: string | number;
  disabled?: boolean;
  minLength?: number;
  maxLength?: number;
  style?: string;
  type?: "text" | "String" | "number" | "Integer" | string;
  id?: string;
  onChange?: (e: any) => void;
}

export const TextInput = ({
  placeholder,
  value,
  disabled,
  minLength,
  maxLength,
  style,
  id,
  type = "text",
  onChange,
}: IProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      (type === "number" || type === "Integer") &&
      !/[0-9]/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "ArrowRight" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowUp" &&
      e.key !== "ArrowDown"
    ) {
      e.preventDefault();
    }
  };

  return (
    <input
      id={id}
      className={classNames("textfield", style && `${style}`)}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      minLength={minLength}
      maxLength={maxLength}
      inputMode={type === "number" ? "numeric" : "text"}
      pattern={type === "number" ? "[0-9]*" : undefined}
      onKeyDown={handleKeyDown}
    />
  );
};
